import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTable } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { TableColumnDef } from 'src/app/common/table-column-def';
import { CommonService } from 'src/app/service/common.service';
import { HttpBasicService } from 'src/app/service/http-basic.service';
import { ExpiryDashboardDto, ExpiryItemDateDto, ExpiryItemDto, ReqGetExpiryAlert, ReqGetExpiryDashboard, ReqGetExpiryGroupByJan, RspGetExpiryAlert, RspGetExpiryDashboard, RspGetExpiryGroupByJan } from 'src/app/webservice/item-expiry';
import { ExpiryAlertRec } from '../0_def/expiry-alert';
import { DialogService } from 'src/app/service/dialog.service';
import { PrinterService } from 'src/app/service/printer.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ItemExpiryInitialDialogComponent } from '../item-expiry-initial-dialog/item-expiry-initial-dialog.component';
import { ExpiryGroup } from '../0_def/expiry-item-rec';
import { ItemExpiryService } from '../1_service/item-Expiry.service';
import { OrderGroupDto } from 'src/app/webservice/order-group';

export interface AlertListItem {
  descIndex:  number;
  alertRec:   ExpiryAlertRec;
}

@Component({
  selector: 'app-item-expiry',
  templateUrl: './item-expiry.component.html',
  styleUrls: ['./item-expiry.component.css']
})
export class ItemExpiryComponent implements OnInit, OnDestroy {

  public isDirty: boolean = false;
  public storeForm: FormControl = new FormControl();
  public targetDateForm: FormControl = new FormControl();
 
  public columnIdsDashboard: string[] = [
    "orderGroup", "itemCount", "nonRegistItemCount", "operation"
  ];
  public columnDefsDashboard: TableColumnDef[] = [
    {columnId: "orderGroup", header: this.commonService.literal["itemExpiryGroup"], width: 100, align: "left"},
    {columnId: "itemCount", header: "商品数", width: 90, align: "right"},
    {columnId: "nonRegistItemCount", header: "未登録商品数", width: 90, align: "right"}
  ];
  public dashboardList: ExpiryDashboardDto[] = [];
  public selectedDashboard: ExpiryDashboardDto;
  public selectedDashboardItem: ExpiryDashboardDto;
  public selectedDashboardNonRegistItem: ExpiryDashboardDto;
  public columnIdsAlertHdr: string[] = [
    "itemDesc", "expiryDate", "productionDate", "alertMsg", "alertOperation"
  ];
  public columnIdsAlert: string[] = [
    "itemDesc", "expiryDate", "productionDate", "alertMsg", "alertOperation", "itemOperation"
  ];
  public columnDefsAlert: TableColumnDef[] = [
    {columnId: "expiryDate", header: "賞味期限", width: 70, align: "center"},
    {columnId: "productionDate", header: "製造年月日", width: 70, align: "center"},
  ];
  public columDefAlertMsg: TableColumnDef = {columnId: "alertMsg", header: "アラート", width: 120, align: "left"};
  public alertRecList: ExpiryAlertRec[];
  public recordCount: number = 0;
  public alertShowList: ExpiryAlertRec[];
  public selectedAlertItem: ExpiryAlertRec;
  public today: Date;
  private subsc: Subscription[] = [];

  @ViewChild(MatPaginator, {static:false}) matPagenator: MatPaginator;
  @ViewChild(MatTable, { static: false }) matTable: MatTable<any>;

  constructor(
    public commonService: CommonService,
    private httpBasic: HttpBasicService,
    private dialogService: DialogService,
    private printerService: PrinterService,
    private itemExpiryService: ItemExpiryService,
    private _snackBar: MatSnackBar
  ) {
    this.today = commonService.getToday();
  }

  ngOnInit(): void {
    this.commonService.pageTitle = this.commonService.pageMenuName;
    this.storeForm.setValue(this.commonService.loginUser.storeCd);
    this.targetDateForm.setValue(this.today);
    this.subsc.push(this.storeForm.valueChanges.subscribe(
      (val) => {
        this.getAlertDashboard();
      }
    ));
    this.subsc.push(this.targetDateForm.valueChanges.subscribe(
      (val) => {
        this.getAlertDashboard();
      }
    ));

    this.printerService.getPrinterLayoutList();
    this.getAlertDashboard();
  }

  ngOnDestroy(): void {
    this.subsc.forEach((subsc) => {subsc.unsubscribe();});
    if (this.printerService.printer?.isConnected()) this.printerService.printer.disconnect();
  }

  @HostListener('window:resize', ['$event'])
  handleResize() {
    this.setTableHeight();
  }

  setTableHeight() {
    setTimeout(() => { this.setTableHeightBody(); }, 0);
  }

  setTableHeightBody() {
    let id = "table-box-dashboard";
    let remHeight = this.commonService.getHeightBelow(id);
    let paginatorHeight = 0;    // 56;
    let margin = 10;
    let itemBox = 0;
    let btnBox = 0;             // 24;
    let height = remHeight - paginatorHeight - margin - itemBox - btnBox;
    if (height < 200) height = 200;

    let elem = document.getElementById(id);
    if (elem) elem.style.maxHeight = "" + height + "px";

    id = "alert-list-box";
    remHeight = this.commonService.getHeightBelow(id);
    paginatorHeight = 56;
    margin = 10;
    itemBox = 0;
    btnBox = 0;
    height = remHeight - paginatorHeight - margin - itemBox - btnBox;
    if (height < 200) height = 200;

    elem = document.getElementById(id);
    if (elem) elem.style.maxHeight = "" + height + "px";
  }

  getAlertDashboard(selectItem?: ExpiryDashboardDto, selectNonregistItem?: ExpiryDashboardDto) {
    this.dashboardList = [];
    this.alertRecList = undefined;
    this.alertShowList = undefined;
    this.selectedDashboard = undefined;
    this.selectedDashboardItem = undefined;
    this.selectedDashboardNonRegistItem = undefined;
    this.selectedAlertItem = undefined;

    let request: ReqGetExpiryDashboard = {
      access: this.commonService.loginUser,
      storeCd: this.storeForm.value,
      targetDate: this.commonService.formatDate(this.targetDateForm.value)
    };

    let ref = this.commonService.openSpinnerForSubComp(this.commonService.pageTitle, "検索中・・・");
    let subsc = this.httpBasic.generalRequest("GetExpiryDashboard", request).subscribe(
      (response: RspGetExpiryDashboard) => {
        this.commonService.closeSpinnerForSubComp(ref);
        subsc.unsubscribe();
        this.receiveAlertDashboard(response, selectItem, selectNonregistItem);
      },
      (error) => {
        this.commonService.closeSpinnerForSubComp(ref);
        subsc.unsubscribe();
        this.httpBasic.handleError(error);
      }
    );
  }

  receiveAlertDashboard(response: RspGetExpiryDashboard, selectItem?: ExpiryDashboardDto, selectNonregistItem?: ExpiryDashboardDto) {
    if (this.httpBasic.handleAppError(response)) return;

    this.dashboardList = response.rows;
    if (selectItem) {
      let rec = this.dashboardList.find((item) => item.groupUsrCd === selectItem.groupUsrCd);
      if (rec?.itemCount > 0) this.showAlert(rec);
    } else if (selectNonregistItem) {
      let rec = this.dashboardList.find((item) => item.groupUsrCd === selectNonregistItem.groupUsrCd);
      if (rec?.nonRegistItemCount > 0) this.showAlertNonRegist(rec);
    }

    this.setTableHeight();
  }

  showAlert(item: ExpiryDashboardDto) {
    if (item.itemCount <= 0) return;
    if (this.selectedDashboardItem === item) return;
    let deact = this.canDeactivate();
    if (deact === true) {
      this.showAlertBody(item);
    } else {
      deact.subscribe(
        (response) => {
          if (response) this.showAlertBody(item);
        }
      );
    }
  }

  showAlertNonRegist(item: ExpiryDashboardDto) {
    if (item.nonRegistItemCount <= 0) return;
    if (this.selectedDashboardNonRegistItem === item) return;
    let deact = this.canDeactivate();
    if (deact === true) {
      this.showAlertNonRegistBody(item);
    } else {
      deact.subscribe(
        (response) => {
          if (response) this.showAlertNonRegistBody(item);
        }
      );
    }
  }

  showAlertBody(item: ExpiryDashboardDto) {
    this.alertRecList?.forEach((rec) => rec.cleanupEdit());
    this.alertRecList = undefined;
    this.alertShowList = undefined;
    this.selectedDashboard = item;
    this.selectedDashboardItem = item;
    this.selectedDashboardNonRegistItem = undefined;

    this.selectedAlertItem = undefined;
    this.getAlertRec(item, 1);
    this.setTableHeight();
  }

  showAlertNonRegistBody(item: ExpiryDashboardDto) {
    this.alertRecList?.forEach((rec) => rec.cleanupEdit());
    this.alertRecList = undefined;
    this.alertShowList = undefined;
    this.selectedDashboard = item;
    this.selectedDashboardItem = undefined;
    this.selectedDashboardNonRegistItem = item;
    this.selectedAlertItem = undefined;
    this.getAlertRec(item, 2);
    this.setTableHeight();
  }

  getAlertRec(item: ExpiryDashboardDto, mode: number) {
    let request: ReqGetExpiryAlert = {
      access: this.commonService.loginUser,
      mode: mode,
      storeCd: item.storeCd,
      groupUsrCd: item.groupUsrCd,
      // maxCtgLevel: this.commonService.config.maxCtgLevel
      targetDate: this.commonService.formatDate(this.targetDateForm.value)
    };

    this.commonService.openSpinner(this.commonService.pageTitle, "検索中・・・");
    let subsc = this.httpBasic.generalRequest("GetExpiryAlert", request).subscribe(
      (response: RspGetExpiryAlert) => {
        this.commonService.closeSpinner();
        subsc.unsubscribe();
        this.receiveGetAlertRec(response);
      },
      (error) => {
        this.commonService.closeSpinner();
        subsc.unsubscribe();
        this.httpBasic.handleError(error);
      }
    );
  }

  receiveGetAlertRec(response: RspGetExpiryAlert) {
    this.isDirty = false;
    this.alertRecList = [];
    let itemMap: Map<string, ExpiryAlertRec> = new Map<string, ExpiryAlertRec>();

    response.alerts.forEach((dto) => {
      let item = itemMap.get(dto.itemCd);
      if (!item) {
        item = new ExpiryAlertRec(this.commonService, this.httpBasic);
        item.storeCd = dto.storeCd;
        item.itemCd = dto.itemCd;
        item.setTargetDate(this.targetDateForm.value);
        let itemDto: ExpiryItemDto = {
          storeCd:            dto.storeCd,
          itemCd:             dto.itemCd,
          itemName:           dto.itemName,
          itemStandard:       dto.itemStandard,
          price:              dto.itemSalesPrice,
          tax:                dto.itemTax,
          expiryType:         dto.expiryType,
          discountType:       dto.discountType,
          datesToExpiry0:     dto.datesToExpiry0,
          datesToExpiry1:     dto.datesToExpiry1,
          datesToExpiry2:     dto.datesToExpiry2,
          datesToExpiry3:     dto.datesToExpiry3,
          datesToExpiry4:     dto.datesToExpiry4,
          action0:            dto.action0,
          action1:            dto.action1,
          action2:            dto.action2,
          action3:            dto.action3,
          action4:            dto.action4,
          discount0:          dto.discount0,
          discount1:          dto.discount1,
          discount2:          dto.discount2,
          discount3:          dto.discount3,
          discount4:          dto.discount4,
        };
        let orderGroupDto: OrderGroupDto = {
          storeCd:            dto.storeCd,
          orderGroupId:       dto.groupId,
          orderGroupUsrCd:    dto.groupUsrCd,
          orderGroupName:     dto.groupName,
          beginDate:          dto.beginDate,
          endDate:            dto.endDate
        }
        item.initExpiryItemDto(itemDto);
        item.initOrderGroupDto(response.groups.filter((dto) => dto.itemCd === item.itemCd));
        this.alertRecList.push(item);
        itemMap.set(item.itemCd, item);
      }
      if (dto.itemDate !== "") {
        let expiryItemDateDto: ExpiryItemDateDto = {
          storeCd:            dto.storeCd,
          itemCd:             dto.itemCd,
          groupId:            dto.groupId,
          groupUsrCd:         dto.groupUsrCd,
          itemDate:           dto.itemDate,
          alertStartDate1:    dto.alertStartDate1,
          alertStartDate2:    dto.alertStartDate2,
          alertStartDate3:    dto.alertStartDate3,
          alertStartDate4:    dto.alertStartDate4,
          alertStartDate5:    dto.alertStartDate5,
          isCompleted1:       dto.isCompleted1,
          isCompleted2:       dto.isCompleted2,
          isCompleted3:       dto.isCompleted3,
          isCompleted4:       dto.isCompleted4,
          isCompleted5:       dto.isCompleted5,
          isSoldOut:          dto.isSoldOut,
          soldOutDate:        dto.soldOutDate,
        };
        item.addExpiryItemDateDto(expiryItemDateDto);
      }
    });
    this.alertRecList.forEach((rec) => {
      rec.initComplete(this.selectedDashboard.groupUsrCd);
      rec.setChangeListener(this.dirtyListener.bind(this));
      // rec.prepareEdit();
    });

    this.recordCount = this.alertRecList.length;
    this.buildAlertShowList();
    this.setTableHeight();
  }

  /*
  receiveGetAlertRec(response: RspGetExpiryAlert) {
    if (this.httpBasic.handleAppError(response)) return;

    this.isDirty = false;
    this.alertRecList = [];
    let currentExpiryAlert: ExpiryAlertRec = undefined;
    response.alerts.forEach((dto) => {
      if (currentExpiryAlert === undefined || currentExpiryAlert.itemCd !== dto.itemCd) {
        currentExpiryAlert = new ExpiryAlertRec(this.commonService);
        currentExpiryAlert.storeCd = dto.storeCd;
        currentExpiryAlert.itemCd = dto.itemCd;
        currentExpiryAlert.itemName = dto.itemName;
        currentExpiryAlert.itemStandard = dto.itemStandard;
        currentExpiryAlert.itemSalesPrice = dto.itemSalesPrice;
        currentExpiryAlert.itemTax = dto.itemTax;
        currentExpiryAlert.groupId = dto.groupId;
        currentExpiryAlert.groupUsrCd = dto.groupUsrCd;
        currentExpiryAlert.groupName = dto.groupName;
        currentExpiryAlert.expiryType = dto.expiryType;
        currentExpiryAlert.discountType = dto.discountType;
        currentExpiryAlert.dateDef = dto.dateDef;
        currentExpiryAlert.alertDescs = [];
        // currentExpiryAlert.itemGroups = dto.itemGroups;
        currentExpiryAlert.itemGroups = undefined;
        currentExpiryAlert.setChangeListener(this.dirtyListener.bind(this));
        this.alertRecList.push(currentExpiryAlert);
      }

      let desc: ExpiryAlertDesc = {
        alertType: dto.alertType,
        itemDate: dto.itemDate,
        alertRank: 0,
        alertStartDate: "",
        alertMsg: "",
        isCompleted: false,
        isCompletedAll: dto.isCompleted,
        isSoldOut: dto.isSoldOut,
        alertStartDates: []
      };
      for (let i = 0; i < currentExpiryAlert.dateDef.length; i++) {
        let d = this.commonService.getDate(desc.itemDate);
        if (currentExpiryAlert.expiryType === 1) {
          d.setDate(d.getDate() - currentExpiryAlert.dateDef[i].datesToExpiry);
        } else {
          d.setDate(d.getDate() + currentExpiryAlert.dateDef[i].datesToExpiry);
        }
        desc.alertStartDates.push(d);
      }
      let itemDate = this.commonService.getDate(desc.itemDate);
      for (let i = 0; i < desc.alertStartDates.length; i++) {
        if (itemDate.getTime() >= desc.alertStartDates[i].getTime()) {
          desc.alertRank = i + 1;
          desc.alertStartDate = this.commonService.formatDate(desc.alertStartDates[i]);
          desc.alertMsg = currentExpiryAlert.dateDef[i].action;
          desc.isCompleted = dto.isCompleted[i]
          break;
        }
      }
      currentExpiryAlert.alertDescs.push(desc);
    });
    this.alertRecList.forEach((rec => rec.prepareEdit()));
    this.recordCount = this.alertRecList.length;
    this.buildAlertShowList();
    this.setTableHeight();
  }
  */

  buildAlertShowList() {
    if (!this.alertRecList) {
      this.alertShowList = undefined;
      return;
    }
    this.alertShowList?.forEach((rec) => rec.setChangeListener(undefined));

    let start: number = 0;
    let end: number = this.commonService.paginatorOption.pageSizeOptions[this.commonService.paginatorOption.pageSizeIndex];
    if (this.matPagenator) {
      start = this.matPagenator.pageIndex * this.matPagenator.pageSize;
      end = start + this.matPagenator.pageSize;
    }

    this.alertShowList = [];
    for (let i = start; i < this.alertRecList.length && i < end; i++) {
      this.alertShowList.push(this.alertRecList[i]);
    }
    if (this.alertShowList.length == 0) {
      this.alertShowList = undefined;
      return;
    }
    this.isDirty = false;
    this.alertShowList.forEach((rec) => {
      this.alertShowList?.forEach((rec) => rec.setChangeListener(this.dirtyListener.bind(this)));
      if (!rec.targetGroup.edit) rec.prepareEdit();
      if (rec.dirty()) this.isDirty = true;
    });

    document.getElementById("alert-list-box")?.scrollTo(0, 0);
  }

  selectAlertItem(item: ExpiryAlertRec) {
    this.selectedAlertItem = item;
  }


  openRegistDialogDashboard(item: ExpiryDashboardDto) {

    this.commonService.dialog.open(ItemExpiryInitialDialogComponent, {
      // position: {top: "10px"},
      // width: "95vw",
      // maxWidth: "95vw",
      minWidth: "1150px",
      minHeight: "90vh",
      disableClose: true,
      data: item
    }).afterClosed().subscribe(
      () => {
        this.getAlertDashboard(this.selectedDashboardItem, this.selectedDashboardNonRegistItem);
      }
    );
  }

  pageChanged(event: PageEvent) {
    let confirm = this.canDeactivate();
    if (confirm === true) {
      this.buildAlertShowList();
    } else {
      confirm.subscribe((ret) => {
        if (ret) {
          this.buildAlertShowList();
        }
      });
    }
  }

  openLabelPrinterDialog() {
    this.dialogService.openLabelPrinterDialog(this.printerService);
  }

  printerNotReady() {
    if (!this.printerService.printerConfig) return true;
    if (!this.printerService.printerConfig.printer) return true;
    if (!this.printerService.printerConfig.printer.isConnected()) return true;
    return false;
  }

  updateIsDirty() {
    this.isDirty = false;
    for (let i = 0; i < this.alertShowList.length; i++) {
      if (this.alertShowList[i].dirty()) {
        this.isDirty = true;
        return;
      }
    }
  }

  dirtyListener(mode: boolean) {
    this.updateIsDirty();
    if (this.isDirty) {
      this.storeForm.disable({emitEvent: false});
      this.targetDateForm.disable({emitEvent: false});
    } else {
      this.storeForm.enable({emitEvent: false});
      this.targetDateForm.enable({emitEvent: false});
    }
  }

  /*
  saveAlert() {
    let rows: UpdateExpiryAlertDto[] = [];
    this.alertRecList.forEach((rec) => {
      let dtos = rec.getSaveData();
      dtos.forEach((dto) => rows.push(dto));
    });

    let request: ReqSaveExpiry = {
      access: this.commonService.loginUser,
      dates: [],
      alerts: rows,
      expiryGroupLabel: this.commonService.literal["itemExpiryGroup"]
    };

    this.commonService.openSpinner(this.commonService.pageTitle, "更新中・・・");
    let subsc = this.httpBasic.generalRequest("SaveExpiry", request).subscribe(
      (response: RspSaveExpiry) => {
        this.commonService.closeSpinner();
        subsc.unsubscribe();
        this.receivesSveAlert(response);
      },
      (error) => {
        this.commonService.closeSpinner();
        subsc.unsubscribe();
        this.httpBasic.handleError(error);
      }
    );
  }

  receivesSveAlert(response: RspSaveExpiry) {
    if (this.httpBasic.handleAppError(response)) return;

    this.alertRecList.forEach((rec) => rec.commitEdit());
    this.isDirty = false;
    this.storeForm.enable({emitEvent: false});
  }
  */

  getGroupName(item: ExpiryDashboardDto) {
    if (item?.groupName) return item.groupUsrCd + "：" + item.groupName;
    return item.groupUsrCd;
  }

  getExpiryGroup(item: ExpiryAlertRec): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      let request: ReqGetExpiryGroupByJan = {
        access: this.commonService.loginUser,
        storeCd: item.storeCd,
        itemCd: item.itemCd
      };

      let ref = this.commonService.openSpinnerForSubComp(this.commonService.pageTitle, "検索中・・・");
      let subsc = this.httpBasic.generalRequest("GetExpiryGroupByJan", request).subscribe(
        (response: RspGetExpiryGroupByJan) => {
            this.commonService.closeSpinnerForSubComp(ref);
            subsc.unsubscribe();
            if (this.httpBasic.handleAppError(response)) reject();
            item.itemGroups = response.itemGroups;
            resolve();
        },
        (error) => {
          this.commonService.closeSpinnerForSubComp(ref);
          subsc.unsubscribe();
          this.httpBasic.handleError(error);
          reject();
        }
      );
    });
  }

  expiryRecUpdated(item: ExpiryAlertRec) {
    if (!this.selectedDashboardNonRegistItem) return;
    if (item.targetGroup?.expiryItemDate?.length > 0) {
      let index = this.alertRecList.findIndex((rec) => rec.itemCd == item.itemCd);
      if (index >= 0) {
        this.alertRecList.splice(index, 1);
        this.recordCount--;
        this.selectedDashboardNonRegistItem.nonRegistItemCount--;
        this.buildAlertShowList();
      }
    }
  }

  removedFromGroup(group: ExpiryGroup) {
      this.getAlertDashboard(this.selectedDashboardItem, this.selectedDashboardNonRegistItem);
  }

  dirty() {
    return this.isDirty;
  }

  canDeactivate() {
    if (!this.isDirty) return true;
    return this.commonService.openYesNoDialog(this.commonService.pageTitle, "変更が保存されていません。変更内容を破棄しますか？");
  }
}
